/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PaymentTransactionStatus_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.PaymentTransactionStatus domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PaymentTransactionStatus_ {
   /// <summary>
   ///   Approved (A)
   /// </summary>
   Approved = 0,
   /// <summary>
   ///   Declined (D)
   /// </summary>
   Declined = 1
}

export const PaymentTransactionStatuses: PaymentTransactionStatus[] = [
   {
      code: PaymentTransactionStatus_.Approved,
      literal: 'Approved',
      description: 'Approved',
      shortDescription: 'A',
      listPriority: 0,

      typeName: "PaymentTransactionStatus"
   },
   {
      code: PaymentTransactionStatus_.Declined,
      literal: 'Declined',
      description: 'Declined',
      shortDescription: 'D',
      listPriority: 0,

      typeName: "PaymentTransactionStatus"
   }
]

export class PaymentTransactionStatus implements IDomainModel {
   code: PaymentTransactionStatus_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PaymentTransactionStatus_): PaymentTransactionStatus {
      return PaymentTransactionStatuses.find(d => d.code === code)
   }
}
